import React, { useState, useEffect } from "react";

export default function GatewayFormModal({ gateway, customerId, onClose, onSaved }) {
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");

  const [form, setForm] = useState({
    name: "",
    ip_address: "",
    port: 502,
    model: "",
    mode: "client",
    description: "",
    customer_id: "",
    latitude: "",
    longitude: "",
  });

  const [error, setError] = useState("");

  useEffect(() => {
    if (gateway) {
      // 🛠️ Düzenleme modu
      setForm({
        name: gateway.name || "",
        ip_address: gateway.ip_address || "",
        port: gateway.port || 502,
        model: gateway.model || "",
        mode: gateway.mode || "client",
        description: gateway.description || "",
        customer_id: gateway.customer_id || "",
        latitude: gateway.latitude || "",
        longitude: gateway.longitude || "",
      });
    } else {
      // ➕ Yeni ekleme
      const storedId = customerId || localStorage.getItem("customerId");
      setForm((prev) => ({
        ...prev,
        customer_id: storedId ? Number(storedId) : "",
      }));
    }
  }, [gateway, customerId]);

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  function validateForm() {
    if (!form.name.trim()) return "Gateway adı boş olamaz.";
    const ipRegex =
      /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/;
    if (!form.ip_address.trim()) return "IP adresi boş olamaz.";
    if (!ipRegex.test(form.ip_address.trim()))
      return "Geçerli bir IP adresi giriniz (örn: 192.168.1.100)";
    if (!form.port || Number(form.port) <= 0) return "Geçerli bir port giriniz.";
    if (!form.model.trim()) return "Model boş olamaz.";
    if (!form.mode.trim()) return "Mode seçiniz.";
    if (!form.description.trim()) return "Açıklama boş olamaz.";
    if (!form.customer_id || Number(form.customer_id) <= 0)
      return "Müşteri ID boş veya 0 olamaz.";

    // 🌍 Konum (isteğe bağlı ama format kontrolü)
    if (form.latitude && isNaN(Number(form.latitude)))
      return "Latitude sayısal olmalıdır.";
    if (form.longitude && isNaN(Number(form.longitude)))
      return "Longitude sayısal olmalıdır.";

    return null;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const validationError = validateForm();
    if (validationError) {
      setError(validationError);
      return;
    }

    const payload = {
      ...form,
      port: Number(form.port),
      customer_id: Number(form.customer_id),
      latitude: form.latitude ? Number(form.latitude) : null,
      longitude: form.longitude ? Number(form.longitude) : null,
    };

    const method = gateway ? "PUT" : "POST";
    const url = gateway
      ? `${API_BASE}/gateways/${gateway.id}`
      : `${API_BASE}/gateways`;

    try {
      const res = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error("HTTP " + res.status);
      await onSaved();
      onClose();
    } catch (err) {
      console.error("❌ Save gateway error:", err);
      setError("Kaydetme sırasında hata oluştu.");
    }
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
        <h2 className="text-lg font-bold mb-4">
          {gateway ? "Gateway Düzenle" : "Gateway Ekle"}
        </h2>

        {error && (
          <div className="mb-4 text-sm text-red-600 bg-red-100 p-2 rounded">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            name="name"
            placeholder="Ad *"
            value={form.name}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
            required
          />
          <input
            name="ip_address"
            placeholder="IP Adresi *"
            value={form.ip_address}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
            required
          />
          <input
            name="port"
            type="number"
            placeholder="Port *"
            value={form.port}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
            required
          />
          <input
            name="model"
            placeholder="Model *"
            value={form.model}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
            required
          />
          <select
            name="mode"
            value={form.mode}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
            required
          >
            <option value="">Seçiniz</option>
            <option value="client">Client</option>
            <option value="server">Server</option>
          </select>
          <textarea
            name="description"
            placeholder="Açıklama *"
            value={form.description}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
            required
          />

          {/* 🌍 Konum Bilgileri */}
          <div className="grid grid-cols-2 gap-4">
            <input
              name="latitude"
              type="number"
              step="0.000001"
              placeholder="Latitude (örn: 38.433)"
              value={form.latitude}
              onChange={handleChange}
              className="w-full border px-3 py-2 rounded"
            />
            <input
              name="longitude"
              type="number"
              step="0.000001"
              placeholder="Longitude (örn: 27.145)"
              value={form.longitude}
              onChange={handleChange}
              className="w-full border px-3 py-2 rounded"
            />
          </div>

          <div className="flex justify-end gap-2 pt-2">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300"
            >
              İptal
            </button>
            <button
              type="submit"
              className="px-4 py-2 rounded bg-indigo-600 text-white hover:bg-indigo-700"
            >
              Kaydet
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
